import { APICallV2Post } from '../APICall';

export class ShareApiCall extends APICallV2Post {
    _method = 'folder/share';
}
